export default __webpack_public_path__ + "static/media/logo3.6030e094.PNG";